const steps = [
  {
    num: "01",
    icon: "ri-scan-2-line",
    title: "Sample or Drawing Intake",
    desc: "Submit your worn engine block, OEM part number, or CAD file. No original blueprints required — our reverse engineering team handles everything from physical samples.",
  },
  {
    num: "02",
    icon: "ri-ruler-2-line",
    title: "3D Scanning & Engineering",
    desc: "We perform high-resolution 3D scanning and dimensional analysis to create precise manufacturing drawings. Every critical dimension is verified against OEM tolerances.",
  },
  {
    num: "03",
    icon: "ri-fire-line",
    title: "Pattern Making & Casting",
    desc: "Custom patterns are produced and the casting process begins. Our foundry controls every metallurgical parameter to ensure consistent mechanical properties.",
  },
  {
    num: "04",
    icon: "ri-cpu-line",
    title: "CNC Machining",
    desc: "Cast blanks are transferred to our CNC machining centers for precision boring, milling, and drilling. All critical surfaces are machined to OEM specification.",
  },
  {
    num: "05",
    icon: "ri-shield-check-line",
    title: "CMM Inspection & Testing",
    desc: "Every finished block undergoes CMM dimensional inspection, ultrasonic flaw detection, and pressure testing. Full inspection reports accompany each shipment.",
  },
  {
    num: "06",
    icon: "ri-ship-line",
    title: "Export & Delivery",
    desc: "We handle all export documentation, customs clearance, and multimodal logistics. Your order arrives at your port with complete paperwork.",
  },
];

export default function FMProcess() {
  return (
    <section
      className="py-24 px-6"
      style={{ background: "#fffbf5" }}
    >
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <div
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-6"
            style={{ background: "rgba(217,119,6,0.08)", border: "1px solid rgba(217,119,6,0.25)" }}
          >
            <i className="ri-flow-chart text-xs" style={{ color: "#D97706" }} />
            <span
              className="text-xs font-semibold tracking-widest uppercase"
              style={{ color: "#D97706", letterSpacing: "0.2em" }}
            >
              Our Process
            </span>
          </div>
          <h2
            className="font-black mb-4"
            style={{ fontSize: "clamp(2rem, 4vw, 3.2rem)", color: "#1a1a1a", letterSpacing: "-0.01em" }}
          >
            From Sample to
            <br />
            <span style={{ color: "#D97706" }}>Shipment-Ready</span>
          </h2>
          <p
            className="text-base font-light max-w-xl mx-auto"
            style={{ color: "rgba(30,20,5,0.55)", lineHeight: "1.85" }}
          >
            A transparent, step-by-step manufacturing process designed for B2B partners
            who demand reliability and traceability at every stage.
          </p>
        </div>

        {/* Steps grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {steps.map((step) => (
            <div
              key={step.num}
              className="rounded-2xl p-7 transition-all duration-300 cursor-default group"
              style={{
                background: "#ffffff",
                border: "1px solid rgba(217,119,6,0.15)",
              }}
              onMouseEnter={(e) => {
                (e.currentTarget as HTMLDivElement).style.borderColor = "rgba(217,119,6,0.4)";
                (e.currentTarget as HTMLDivElement).style.background = "rgba(255,248,235,0.8)";
              }}
              onMouseLeave={(e) => {
                (e.currentTarget as HTMLDivElement).style.borderColor = "rgba(217,119,6,0.15)";
                (e.currentTarget as HTMLDivElement).style.background = "#ffffff";
              }}
            >
              <div className="flex items-start justify-between mb-5">
                <div
                  className="w-12 h-12 flex items-center justify-center rounded-xl"
                  style={{ background: "rgba(217,119,6,0.1)" }}
                >
                  <i className={`${step.icon} text-xl`} style={{ color: "#D97706" }} />
                </div>
                <span
                  className="font-black"
                  style={{ fontSize: "2.5rem", color: "rgba(217,119,6,0.12)", lineHeight: 1 }}
                >
                  {step.num}
                </span>
              </div>
              <h3
                className="font-black text-base mb-3"
                style={{ color: "#1a1a1a" }}
              >
                {step.title}
              </h3>
              <p
                className="text-sm font-light leading-relaxed"
                style={{ color: "rgba(30,20,5,0.6)", lineHeight: "1.8" }}
              >
                {step.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
